export const SET_BUTTON_URL = "SET_BUTTON_URL";

export const setButtonUrl = (data) => ({
  type: SET_BUTTON_URL,
  payload: data,
});
